import { useDropzone } from "react-dropzone";
import { $crud } from "../helper/CrudFactory";

export default function Dropzone({ onDrop, children, err }) {
  const { getRootProps, isDragActive } = useDropzone({
    onDrop: onDrop,
    noDragEventsBubbling: true,
    noClick: true,
    accept: [
      ".jpg",
      ".png",
      ".jpeg",
      ".JPG",
      ".PNG",
      ".JPEG",
      ".gif",
      ".bmp",
      ".webp",
      ".heic",
      ".heif",
      ".HEIC",
      ".mpg",
      ".mpeg",
      ".mov",
      ".mp4",
      ".webm",
      ".m4v",
      ".doc",
      ".docx",
      ".txt",
      "application/pdf",
      ".odt",
      ".xls",
      ".xlsx",
      ".xlsb", ".odt", ".xlsm", '.ppt', '.dwg', '.odf', '.ifc','.dwg','.dxf','.xlsm', '.pptx', '.csv', '.txt', '.mpp', '.json', '.zip'
    ],
    multiple: true,
    onDropRejected: (event) => {
      const message = event?.[0]?.errors?.[0]?.message;
      if (message) {
        $crud.notify({
          type: "error",
          message: err ? err : message,
        });
      }
    },
  });

  return (
    <div {...getRootProps({ 
      style: { flex: "1 1 0", display: "flex", flexDirection: "column", minHeight: 0, position: "relative" }
    })}>
      {/* Keep children mounted during drag so chat scroll position is preserved */}
      {children}
      {isDragActive && (
        <div className="dropzone-overlay">
          <p>Drop File Here</p>
        </div>
      )}
    </div>
  );
}
